<template>
  <span class="bi bi-enlarged text-white" :class="iconClass"
         :title="transactionType || ''"></span>
</template>

<script setup>
import { computed, defineProps } from 'vue'
const props = defineProps({
  transactionType: String
})

const iconClass = computed(() => {
  switch (props.transactionType) {
    case 'SHIPPING_LABEL':
      return 'bi-truck bg-info'
    case 'SALE':
      return 'bi-cart2 bg-success'
    case 'AD_FEE':
    case 'NON_SALE_CHARGE':
      return 'bi-badge-ad bg-secondary'
    case 'REFUND':
      return 'bi-arrow-return-left bg-warning'
    case 'COGS':
      return 'bi-coin bg-danger'
    default:
      return 'bi-circle bg-black'
  }
})

</script>



<style scoped lang="scss">

</style>